import React from "react";

export const BranchType = () => (
  <svg
    width="17"
    height="13"
    viewBox="0 0 17 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.19922 3C13 3 7.1012 11 12.7012 11"
      stroke="black"
      strokeWidth="0.8"
    />
    <circle cx="14.5" cy="10.5" r="2" stroke="black" />
    <circle cx="2.5" cy="2.5" r="2" stroke="black" />
    <circle cx="14.5" cy="2.5" r="2" stroke="black" />
    <rect x="4" y="2" width="9" height="1" fill="black" />
  </svg>
);
